import {useMutation, UseMutationOptions} from "@tanstack/react-query";
import {ResponseError} from "../../../models/common/Response";
import axios, {AxiosError} from "axios";

export type UseDeleteBucketCompanyCodeMappingParams = {
    sid: string;
    company_code: string;
    company_bucket_code: string;
};

export function useDeleteBucketCompanyCodeMapping(
    options?: UseMutationOptions<
        ResponseError,
        AxiosError<ResponseError>,
        UseDeleteBucketCompanyCodeMappingParams
    >
) {
    return useMutation({
        mutationFn: (params) => {
            const accessToken = localStorage.getItem('LG_APPLICATION');
            return axios.delete('/v1/configuration/lis/bucket-company-code-mapping', {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    sid: params?.sid,
                    company_code: params?.company_code,
                    company_bucket_code: params?.company_bucket_code
                },
            });
        },
        ...options,
    });
}